import { Link } from "react-router-dom";
import { Gift, MessageCircle, Sparkles } from "lucide-react";

export default function ReferAFriend() {
  return (
    <main data-testid="refer-a-friend-page" className="min-h-screen bg-ivory">
      <section className="border-b border-line bg-espresso px-4 py-12 text-ivory md:px-10 md:py-24">
        <div className="mx-auto max-w-5xl">
          <div className="label-xs text-gold">TIRAMISÙ &amp; Co. referrals</div>
          <h1 className="mt-4 max-w-3xl font-serif text-4xl leading-[1.05] md:text-6xl">
            Share the love.<br />Savor the reward.
          </h1>
          <p className="mt-6 max-w-xl text-sm leading-relaxed text-ivory/75">
            Give a friend 10% off their first direct order, and earn a free 150g cup for every three friends whose paid orders are delivered.
          </p>
          <Link to="/account" data-testid="refer-account-link" className="mt-8 inline-flex bg-gold px-5 py-3 text-[10px] uppercase tracking-[0.16em] text-espresso">
            Get my referral link
          </Link>
        </div>
      </section>
      <section className="mx-auto grid max-w-5xl gap-8 px-4 py-12 md:grid-cols-3 md:px-10 md:py-20">
        {[
          [MessageCircle, "Share", "Send your personal code or WhatsApp link to a friend."],
          [Sparkles, "They save", "A signed-in friend's first food order of ₹399 or more receives 10% off."],
          [Gift, "You earn", "Every 3 paid, delivered referrals unlock one eligible 150g tiramisu cup for 60 days."],
        ].map(([Icon, title, copy]) => (
          <div key={title} className="border-t border-espresso pt-5">
            <Icon size={19} strokeWidth={1.4} className="text-gold-hover" />
            <h2 className="mt-5 font-serif text-3xl text-espresso">{title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-espresso-light">{copy}</p>
          </div>
        ))}
      </section>
    </main>
  );
}